var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 8.00008V6.93341C21.3333 5.43994 21.3333 4.6932 21.0427 4.12277C20.787 3.62101 20.3791 3.21306 19.8773 2.9574C19.3069 2.66675 18.5601 2.66675 17.0667 2.66675H14.9333C13.4399 2.66675 12.6931 2.66675 12.1227 2.9574C11.6209 3.21306 11.213 3.62101 10.9573 4.12277C10.6667 4.6932 10.6667 5.43994 10.6667 6.93341V8.00008M13.3333 15.3334V22.0001M18.6667 15.3334V22.0001M4 8.00008H28M25.3333 8.00008V22.9334C25.3333 25.1736 25.3333 26.2937 24.8974 27.1494C24.5139 27.902 23.9019 28.5139 23.1493 28.8974C22.2936 29.3334 21.1735 29.3334 18.9333 29.3334H13.0667C10.8265 29.3334 9.70635 29.3334 8.8507 28.8974C8.09806 28.5139 7.48613 27.902 7.10264 27.1494C6.66667 26.2937 6.66667 25.1736 6.66667 22.9334V8.00008",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteOutline);
export default __webpack_public_path__ + "static/media/delete_outline.0c6c0366caea8851d3ccafa78438b0d8.svg";
export { ForwardRef as ReactComponent };